import React from 'react';
import PropTypes from 'prop-types';
import { InstantSearch, Configure } from 'react-instantsearch-dom';
import { searchClient } from 'components/essentials/AlgoliaSearchClient';
import { ReviewSearchOptions, ReviewSearchBox } from '../utils';

const ReviewSearch = props => (
  <div className="relative">
    <InstantSearch searchClient={searchClient} indexName="reviews">
      <Configure
        query={props.searchQuery ? props.searchQuery : ''}
        hitsPerPage={5}
      />
      <ReviewSearchBox onSearchUpdate={props.onSearchUpdate} />
      <ReviewSearchOptions {...props} />
    </InstantSearch>
  </div>
);

ReviewSearch.propTypes = {
  searchQuery: PropTypes.string,
  onSearchUpdate: PropTypes.func,
};

export default ReviewSearch;
